import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import GlobalError from '../components/GlobalError';
import ProductList from '../components/ProductList';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Paper, Chip } from '@mui/material';
const TopPage = () => {
  const [settings, setSettings] = useState({});
  const [newProducts, setNewProducts] = useState([]);
  const [bestSellingProducts, setBestSellingProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await axiosInstance.get('/category/list-with-products');
        setCategories(res.data || []);
      } catch (err) {
        if (err.response?.status === 404) { return; }
        console.error('カテゴリー情報の取得に失敗:', err);
        setCategories([]);
      }
    };

    loadCategories();
  }, []);

  useEffect(() => {
    const fetchProducts = async (
      userEndpoint,
      publicEndpoint,
      setter
    ) => {

      try {

        const response = await axiosInstance.get(
          userEndpoint,
          { withCredentials: true }
        );

        setter(response.data);

      } catch (error) {

        if (error.response?.status === 401) {

          try {

            const publicResponse = await axiosInstance.get(
              publicEndpoint,
              { withCredentials: false }
            );

            setter(publicResponse.data);

          } catch (err) {
            console.error(err);
            setter([]);
          }

        } else {
          console.error(error);
          setter([]);
        }
      }
    };

    const fetchData = async () => {
      try {

        const settingsResponse = await axiosInstance.get(
          '/setting/ec-setting',
          { withCredentials: false }
        );

        setSettings(settingsResponse.data);

        await Promise.all([
          fetchProducts(
            '/product/new/user',
            '/product/new',
            setNewProducts
          ),
          fetchProducts(
            '/product/best-sellers/user',
            '/product/best-sellers',
            setBestSellingProducts
          ),
          fetchProducts(
            '/product/featured/user',
            '/product/featured',
            setFeaturedProducts
          ),
        ]);

      } catch (err) {
        console.error(err);

        setError(
          err.response?.data?.message ||
          err.message ||
          'データの取得に失敗しました'
        );
      }
    };

    fetchData();
  }, []);
  if (error) return <GlobalError errorMessage={error} />;

  return (
    <>
      {/*トップページ*/}
      {settings.main_image_url && (
        <img
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${settings.main_image_url}`}
          alt=""
          style={{ width: "100%" }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = `${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_NOIMAGE}`;
          }}
        />
      )}
      {/* 新商品セクション */}
      {newProducts.length > 0 && (
        <>
          <Typography variant='h2' mt={8} textAlign={'center'}>新商品</Typography>
          <ProductList products={newProducts} />
        </>
      )}

      {/* カテゴリーから探すセクション */}
      {categories.length > 0 && (
        <Paper variant='section' px={3} py={5} sx={{ mt: 8 }}>
          <Typography variant='h2' my={1} align='center'>カテゴリーから探す</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, mt: 2 }}>
            {(categories || []).map(cat => (
              <Chip
                key={cat.category_id}
                label={cat.category_name}
                clickable
                onClick={() => {
                  navigate(`/category/${cat.category_id}`);
                }}
                sx={{ mb: 1 }}
              />
            ))}
          </Box>
        </Paper>
      )}

      {/* イチオシ商品セクション */}
      {featuredProducts.length > 0 && (
        <>
          <Typography variant='h2' mt={8} textAlign={'center'}>イチオシ商品</Typography>
          <ProductList products={featuredProducts} />
        </>
      )}

      {/* 売れ筋商品セクション */}
      {bestSellingProducts.length > 0 && (
        <>
          <Typography variant='h2' mt={8} textAlign={'center'}>売れ筋商品</Typography>
          <ProductList products={bestSellingProducts} />
        </>
      )}
    </>
  );
};

export default TopPage;
